export default __webpack_public_path__ + "static/media/13.f86e8644.jpg";